const isVisible = element => {
  return element.getClientRects().length > 0;
};

export { isVisible as i };
